import styled from 'styled-components';

import { ButtonBase } from '@sorare/core/src/atoms/buttons/ButtonBase';

export const PickerOption = styled(ButtonBase)`
  position: relative;
  border-radius: var(--radius-l);
  border: 2px solid var(--c-nd-150);
  min-width: 110px;

  &.selected {
    border: 2px solid var(--c-white);

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 40%;
      background: radial-gradient(
        ellipse 50% 100% at 50% 140%,
        var(--board-color, var(--c-nd-100)),
        transparent
      );
      pointer-events: none;
    }
  }
`;
